import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_COMPONENT_MATERIAL',
  CREATE: 'CREATE_COMPONENT_MATERIAL',
  EDIT: 'EDIT_COMPONENT_MATERIAL',
  DELETE: 'DELETE_COMPONENT_MATERIAL',
  CLEAR_ERROR: 'CLEAR_ERROR_COMPONENT_MATERIAL',
  STORE_MATERIAL: 'STORE_MATERIAL',
  ADD_MATERIAL:'ADD_MATERIAL_TO_STATE',
  CLEAR_MATERIAL: 'CLEAR_MATERIAL_ON_REDUX',
};

export const addMaterialToComponent = (componentId, materialId, thickness, order) => {
  const data = {
    component_id: componentId,
    material_id: materialId,
    thickness,
    order,
  };
  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_REL_COMPONENT_MATERIAL,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeMaterialFromComponent = componentMaterialId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_REL_COMPONENT_MATERIAL}${componentMaterialId}/`,
    })
      .then(() => ({ id: componentMaterialId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editMaterialFromComponent = (componentMaterialId, thickness, order) => {
  const data = {
    thickness,
    order,
  };
  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_REL_COMPONENT_MATERIAL}${componentMaterialId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const listMaterialInComponent = (pageSize, page, sorted, filtered, isPublic, componentId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_REL_COMPONENT_MATERIAL,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        component_id: componentId,
      },
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorComponentMaterial = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};
export const clearMaterialOpaque = () => {
  return {
    type: ACTION.CLEAR_MATERIAL,
  };
};


// WEBPACK FOOTER //
// ./src/redux/component/component_material_actions.js